// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"4bd260f4","239":"fea026ae","306":"1566d616","389":"0c08d1b6","405":"ce4bbbbb","553":"986c5c47","676":"82f2c89f","689":"801cc879","786":"b32fb15d","977":"ac561f96"}[chunkId] + ".chunk.js";
};